import { jsx as _jsx } from "react/jsx-runtime";
import { displayTimeToRace } from '../../../helpers/date';
import styles from './RaceStats.module.scss';
import { useTranslation } from 'react-i18next';
import { AboutTrack } from '../../../components/AboutTrack/AboutTrack';
const RaceStats = ({ race }) => {
    const { t } = useTranslation();
    const parseRace = {
        [t('entryFee')]: race.entryFee.ada === 0 ? 'Free' : race.entryFee.ada,
        [t('prizePool')]: race,
        [t('nominations')]: { current: 4, total: 16 },
        [t('starts_in')]: displayTimeToRace(race.date),
        [t('distance')]: race.trackDetails.distance,
        [t('requirements')]: race.requirements
    };
    return _jsx(AboutTrack, { elem: parseRace, borderRight: true, className: styles.element });
};
export default RaceStats;
